import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWind, faCircleArrowDown } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface WindStatsProps {
    windSpeed: number;
    windDirection: number;
    isLoaded: boolean;
}

const WindStats: React.FC<WindStatsProps> = ({ windSpeed, windDirection, isLoaded }) => {

    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='lightseagreen' size='2x' icon={faWind} />
                    <FormattedValue isLoaded={isLoaded} value={windSpeed} unit='km/h'></FormattedValue>
                    <FontAwesomeIcon color='grey' size='1x' icon={faCircleArrowDown} style={{ transform: `rotate(${windDirection}deg)` }} />
                </div>
            </div>
}

export default WindStats;
